module.exports = __webpack_public_path__ + "media/images/emblems/Vevey-coat_of_arms-dd498b6644c057473608c801d9d8e962.svg";